import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ExcepcionGMF } from '../_models/excepcion-gmf';

@Injectable({
  providedIn: 'root'
})
export class ExcepcionGmfService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/excepcionesGMF';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ExcepcionGMF [] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ExcepcionGMF [] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ExcepcionGMF ) );
  }

  crear( regCrear: ExcepcionGMF ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ExcepcionGMF ) );
  }

  actualizar( regActualizar: ExcepcionGMF ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regActualizar ).pipe( map( res => res as ExcepcionGMF ) );
  }

  /**Servicio especial para actualizar la configuracion de una excepcion*/
  saveExcepcionesCreditosDesembolsos( regCrear: any ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio + '/saveExcepcionesCreditosDesembolsos', regCrear ).pipe( map( res => res as ExcepcionGMF ) );
  }


}
